import { render, staticRenderFns } from "./LineupGenerator.vue?vue&type=template&id=f5fffb08&scoped=true"
import script from "./LineupGenerator.vue?vue&type=script&lang=js"
export * from "./LineupGenerator.vue?vue&type=script&lang=js"
import style0 from "./LineupGenerator.vue?vue&type=style&index=0&id=f5fffb08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fffb08",
  null
  
)

export default component.exports